import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css';

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-venta-cliente'}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    className: props.columnVisible.establecimiento,
                    sorter: true
                },

                {
                    title: 'Almacen',
                    dataIndex: 'almacen',
                    key: 'almacen',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Documento Vendedor',
                    dataIndex: 'numeroDocumentoVendedor',
                    key: 'numeroDocumentoVendedor',
                    className: props.columnVisible.vendedor,
                    sorter: true
                },

                {
                    title: 'Vendedor',
                    dataIndex: 'nombreVendedor',
                    key: 'nombreVendedor',
                    className: props.columnVisible.vendedor,
                    sorter: true
                },
                {
                    title: 'Cod. Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    className: props.columnVisible.codigoReferencia,
                    sorter: true
                },
                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    className: props.columnVisible.nombre,
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    align: 'right',
                    className: props.columnVisible.cantidad,
                    sorter: true
                },
                {
                    title: 'Unidad Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    className: props.columnVisible.cantidad,
                    sorter: true
                },
                {
                    title: props.texto,
                    dataIndex: 'precioUnitarioStr',
                    key: 'precioUnitarioStr',
                    className: props.columnVisible.detallado,
                    sorter: true,
                },
                {
                    title: 'Cliente',
                    dataIndex: 'nombreCliente',
                    key: 'nombreCliente',
                    className: props.columnVisible.detallado,
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "200px" }}>{value}</div>
                    )
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Tipo',
                    dataIndex: 'tipoComprobanteSunat',
                    key: 'tipoComprobanteSunat',
                    className: props.columnVisible.detallado,
                    sorter: true
                },

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    className: props.columnVisible.detallado,
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambioStr',
                    key: 'tipoCambioStr',
                    className: props.columnVisible.detallado,
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Ingreso por Ventas',
                    dataIndex: 'totalSolesStr',
                    key: 'totalSolesStr',
                    align: 'right',
                    sorter: true
                },
                {
                    title: 'Costo Promedio Total',
                    dataIndex: 'totalPromedioStr',
                    key: 'totalPromedioStr',
                    align: 'right',
                    sorter: true,
                },
                {
                    title: 'Utilidad Bruta',
                    dataIndex: 'totalUtilidadStr',
                    key: 'totalUtilidadStr',
                    align: 'right',
                    sorter: true,
                },
                {
                    title: 'Margen Bruto %',
                    dataIndex: 'margenBruto',
                    key: 'margenBruto',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },


            ]}
        />
    );
}